import React from "react";
import { Pagination } from "antd";

interface CommonPaginationProps {
  meta: { currentPage: number; perPage: number; total: number };
  onChange?: (page: number, pageSize?: number) => void; 
}

const CommonPagination: React.FC<CommonPaginationProps> = ({ meta, onChange }) => {
  if (!meta || meta.total === 0) return null;

  return (
    <div className="flex justify-between items-center px-4 py-3 mt-4 bg-white border-t border-gray-200 sm:px-6">
      {/* Mobile */}
      <div className="flex flex-1 justify-between sm:hidden">
        <button
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-md border border-gray-300 hover:bg-gray-50"
          onClick={() => onChange?.(meta.currentPage - 1, meta.perPage)}
          disabled={meta.currentPage === 1}
        >
          Previous
        </button>
        <button
          className="px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white rounded-md border border-gray-300 hover:bg-gray-50"
          onClick={() => onChange?.(meta.currentPage + 1, meta.perPage)}
          disabled={meta.currentPage === Math.ceil(meta.total / meta.perPage)}
        >
          Next
        </button>
      </div>

      {/* Desktop */}
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <p className="text-sm text-gray-700">
          Showing{" "}
          <span className="font-medium">{(meta.currentPage - 1) * meta.perPage + 1}</span>{" "}
          to{" "}
          <span className="font-medium">{Math.min(meta.currentPage * meta.perPage, meta.total)}</span>{" "}
          of <span className="font-medium">{meta.total}</span> results
        </p>
        <Pagination
          current={meta.currentPage}
          total={meta.total}
          pageSize={meta.perPage}
          onChange={onChange}
          showSizeChanger
        />
      </div>
    </div>
  );
};

export default CommonPagination;
